import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query widgetChannels {
  widgetChannels {
    enable
    link
    name
    type
    identifier
    site
  }
}`;

function getWidgetChannels() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.widgetChannels);
}

export default getWidgetChannels;
